module.exports = __webpack_public_path__ + "34959ea6110b2cc4e56e1a611bcb278c.pdf";